import { Form, Formik } from 'formik';
import { useState } from 'react';

import mail from '../../../assets/icons/Mail.svg';
import User from '../../../assets/icons/User.svg';
import { useRoot } from '../../../context/RootProvider';
import { FormContainer, Input, Typography } from '../../../designComponents';
import ProfileInformation from '../ProfileInformation';
import { PrinterSettingStyled } from './style';

const PrinterSettings = () => {
  const { auth } = useRoot();
  const [initialValues, _setInitialValues] = useState({
    user: auth?.role,
    name: auth?.fullName,
    email: auth?.emailAddress,
  });

  return (
    <PrinterSettingStyled>
      <ProfileInformation />

      <Typography size={14} strong style={{ marginBottom: '20px' }}>
        Personal Information
      </Typography>

      <Formik
        onSubmit={() => {}}
        initialValues={initialValues}
        enableReinitialize
      >
        {({ values, setFieldValue }) => {
          return (
            <Form>
              <FormContainer label="Printer Name" marginBottom="20px">
                <Input
                  name="name"
                  value={values.name}
                  onChange={(e) => setFieldValue('name', e.target.value)}
                  iconLeft={<img src={User} alt="user icon" />}
                  readOnly
                />
              </FormContainer>
              <FormContainer label="Email Address" marginBottom="20px">
                <Input
                  name="email"
                  value={values.email}
                  onChange={(e) => setFieldValue('email', e.target.value)}
                  iconLeft={<img src={mail} alt="mail icon" />}
                  readOnly
                />
              </FormContainer>
            </Form>
          );
        }}
      </Formik>
    </PrinterSettingStyled>
  );
};

export default PrinterSettings;
